import { RandomId } from "@swivl-mono/helpers";
import { NodeData_ShortURL, NodeData_StoreFinderLookup, NodeData_UserValidationNode, NodeInterface, NodeType, VarKey } from "@swivl-mono/types";
import { Select, SelectItem } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const ShortURLNode = {
  Type: NodeType.ShortURL,
  Empty: function () {
    const node = {
      id: RandomId(6),
      type: NodeType.ShortURL,
      saveToVar: VarKey.UserShortURL,
      url: "",
      expiresAfterInMinutes: 0, // in minutes
      goto: ""
    } as NodeData_ShortURL;

    return node; //
  },
  PlumbData: function (_node: NodeInterface) {
    const node = _node as NodeData_ShortURL;

    return TabNodeLayoutData({
      node: node,
      title: "Short URL",
      body: node.url,
      baseWidth: 300,
      tabs: [
        {
          id: "goto",
          source: "goto",
          target: node.goto
        }
      ]
    });
  },

  InspectorPanel: class InputInspectorPanel extends NodePanel {
    render() {
      const node = this.props.node as NodeData_ShortURL;

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Validation" />
            <TagInput label="URL to Shorten" type={TagInputType.SingleLine} value={node.url} onChange={this.onChange} name="url" />

            <label>Save Short URL To</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name={"saveToVar"} value={node.saveToVar} />
            <Select
              label="Expires After"
              hideClear
              selectedValues={[String(node.expiresAfterInMinutes ?? "")]}
              options={
                [
                  { value: "", label: "No Expiration" },
                  { value: "1", label: "1 Minute" },
                  { value: "5", label: "5 Minutes" },
                  { value: "15", label: "15 Minutes" },
                  { value: "30", label: "30 Minutes" },
                  { value: "60", label: "1 Hour" },
                  { value: "120", label: "2 Hours" },
                  { value: "1440", label: "1 Day" }
                ] as SelectItem[]
              }
              onChange={(vals) =>
                this.onChange({ target: { name: "expiresAfterInMinutes", value: vals[0] === "" ? undefined : Number(vals[0]) } } as any)
              }
            />
          </div>
          <InspectorFooter deleteNode={this.deleteNode} node={node} />
        </div>
      );
    }
  }
};
export default ShortURLNode;
